export const ADDNEWFIELD_DIALOG_OPEN = "ADDNEWFIELD_DIALOG_OPEN"
export const ADDNEWFIELD_DIALOG_CLOSE = "ADDNEWFIELD_DIALOG_CLOSE"



// WEBPACK FOOTER //
// ./src/types/actions/add-new-field-dialog.js